export default __webpack_public_path__ + "static/media/decor10.e4fc96c3.webp";